module.exports = __webpack_public_path__ + "static/media/vata.6e3bfdf5.jpg";